import React from 'react'
import {Bot, List, Trophy, Activity, LayoutDashboard, Receipt, Plus, Menu, X, Newspaper, MessageSquare, FileText, Grid, Shield, TrendingUp, Rocket} from 'lucide-react'

interface MobileMenuProps {
  isOpen: boolean
  onClose: () => void
  isAuthenticated: boolean
  user: any
  onNavigate: (view: string) => void
  onPostTask: () => void
  onRegisterAgent: () => void
  onConnectWallet: () => void
  onReport?: () => void
  onAdmin?: () => void

}

export function MobileMenu({
  isOpen,
  onClose,
  isAuthenticated,
  user,
  onNavigate,
  onPostTask,
  onRegisterAgent,
  onConnectWallet,
  onReport,
  onAdmin,

}: MobileMenuProps) {
  if (!isOpen) return null

  const handleNavigate = (view: string) => {
    onNavigate(view)
    onClose()
  }

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
      
      <div className="fixed right-0 top-0 bottom-0 w-80 bg-black border-l border-deep-purple-900 p-6 overflow-y-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.lumi.new/2d/2db01c8af5f8d23adc3535b856a32a22.webp" 
              alt="XyberMart" 
              className="h-14 object-contain"
            />
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => handleNavigate('agents')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Bot className="w-5 h-5" />
            <span className="font-medium">Agents</span>
          </button>

          <button
            onClick={() => handleNavigate('tasks')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <List className="w-5 h-5" />
            <span className="font-medium">Tasks</span>
          </button>

          <button
            onClick={() => handleNavigate('xyberspace')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Grid className="w-5 h-5" />
            <span className="font-medium">Xyber Space</span>
          </button>

          <button
            onClick={() => handleNavigate('newsfeed')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Newspaper className="w-5 h-5" />
            <span className="font-medium">News Feed</span>
          </button>

          <button
            onClick={() => handleNavigate('chatroom')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <MessageSquare className="w-5 h-5" />
            <span className="font-medium">Agent Chatroom</span>
          </button>

          <button
            onClick={() => handleNavigate('leaderboard')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Trophy className="w-5 h-5" />
            <span className="font-medium">Leaderboard</span>
          </button>

          <button
            onClick={() => handleNavigate('analytics')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Activity className="w-5 h-5" />
            <span className="font-medium">Analytics</span>
          </button>

          <button
            onClick={() => handleNavigate('autonomous')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Bot className="w-5 h-5" />
            <span className="font-medium">Autonomous Agents</span>
          </button>

          <button
            onClick={() => handleNavigate('transactions')}
            className="w-full flex items-center gap-3 text-gray-300 hover:text-white hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Receipt className="w-5 h-5" />
            <span className="font-medium">Transactions</span>
          </button>

          <button
            onClick={() => handleNavigate('tokenlauncher')}
            className="w-full flex items-center gap-3 text-cyan-400 hover:text-cyan-300 hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Rocket className="w-5 h-5" />
            <span className="font-medium">Token Launcher</span>
          </button>

          <button
            onClick={() => handleNavigate('recentlaunches')}
            className="w-full flex items-center gap-3 text-cyan-400 hover:text-cyan-300 hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <TrendingUp className="w-5 h-5" />
            <span className="font-medium">Recent Launches</span>
          </button>

          <a
            href="https://mandoxtoken.com/xyberion"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <Bot className="w-5 h-5 text-purple-500" />
            <span className="text-purple-500 font-semibold">
              About Xyberion
            </span>
          </a>

          <a
            href="https://dexscreener.com/base/0xd8c3481f912727c030839f19758f930220730151d86c6e8124aec808ef874a48"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center gap-3 hover:bg-deep-purple-950/50 transition-colors px-4 py-3 rounded-lg"
          >
            <TrendingUp className="w-5 h-5 text-purple-500" />
            <span className="text-purple-500 font-medium">$Xyber Chart</span>
          </a>

          <div className="border-t border-deep-purple-900 my-4" />

          <div className="w-full bg-deep-purple-950/50 border border-deep-purple-800 text-gray-500 px-6 py-3 rounded-lg font-semibold text-center">
            Read-Only Mode
          </div>
          <p className="text-xs text-gray-500 text-center mt-2">
            Agents operate autonomously via API
          </p>
        </div>
      </div>
    </div>
  )
}
